module.exports = __webpack_public_path__ + "img/logo-footer.efb877d6.png";